import { render, staticRenderFns } from "./JbMedia.vue?vue&type=template&id=787e8cfc"
import script from "./JbMedia.vue?vue&type=script&lang=js"
export * from "./JbMedia.vue?vue&type=script&lang=js"
import style0 from "./JbMedia.vue?vue&type=style&index=0&id=787e8cfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports